import * as React from 'react';

interface OwnProps {
	onFileChange: (files: File[]) => void;
	acceptFileTypes: string;
}

type Props = OwnProps;

const FileInput = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
	const { onFileChange, acceptFileTypes } = props;

	const changeFile = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		const filesObj = event.target.files;

		if (!filesObj) {
			return;
		}

		const files = Array.from(filesObj);
		event.target.value = '';
		onFileChange(files);
	}, [onFileChange]);

	return (
		<input
			accept={acceptFileTypes}
			onChange={changeFile}
			ref={ref}
			style={{ display: 'none' }}
			type="file"
		/>
	);
});

export default React.memo(FileInput);
